// extracted by mini-css-extract-plugin
export default {"popup":"SavedPopup_popup__nSso3","active":"SavedPopup_active__10kz5"};